import React from 'react';
import { WebsiteDesignProps } from './types';
import { Maximize2, Move, CreditCard } from 'lucide-react';
import { Button } from "@/components/ui/button";

const GallerySpace: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The White Cube";

    return (
        <div className="bg-white text-black min-h-screen font-sans">
            <nav className="p-12 flex justify-between items-start">
                <div className="text-lg font-bold tracking-tight uppercase max-w-[100px] leading-tight">
                    {schoolName}
                    <span className="block text-gray-400 mt-1">Contemporary Art & Design</span>
                </div>
                <div className="text-right text-sm font-bold uppercase tracking-wide space-y-1">
                    <a href="#" className="block hover:line-through">Exhibitions</a>
                    <a href="#" className="block hover:line-through">Artists</a>
                    <a href="#" className="block hover:line-through">Visit</a>
                </div>
            </nav>

            <main className="container mx-auto px-12">
                <div className="flex flex-col md:flex-row gap-20 items-end mb-32">
                    <div className="md:w-2/3">
                        <img src="https://images.unsplash.com/photo-1545989253-02cc26577f88?q=80&w=2070&auto=format&fit=crop" className="w-full grayscale hover:grayscale-0 transition-all duration-700" alt="Exhibition" />
                    </div>
                    <div className="md:w-1/3 pb-8">
                        <span className="block text-xs font-bold uppercase tracking-widest mb-4 text-gray-400">Current Exhibition</span>
                        <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-8">
                            Reframing <br/> Perspective.
                        </h1>
                        <p className="text-gray-600 mb-8 leading-relaxed text-sm">
                            An exploration of space, light, and form. Our students challenge the boundaries of traditional media to create immersive experiences.
                        </p>
                        <Button variant="outline" className="border-black text-black rounded-none px-8 uppercase text-xs font-bold tracking-widest hover:bg-black hover:text-white">
                            View Gallery
                        </Button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
                    {[
                        { title: "Sculpture", date: "Oct 12 - Nov 05" },
                        { title: "Photography", date: "Nov 10 - Dec 20" },
                        { title: "New Media", date: "Jan 05 - Feb 15" }
                    ].map((item, i) => (
                        <div key={i} className="bg-white p-12 hover:bg-gray-50 transition-colors aspect-square flex flex-col justify-between group">
                            <Maximize2 className="text-gray-300 group-hover:text-black transition-colors" />
                            <div>
                                <h3 className="text-2xl font-bold uppercase tracking-tight mb-2">{item.title}</h3>
                                <div className="text-xs font-bold uppercase tracking-widest text-gray-400">{item.date}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
};

export default GallerySpace;
